import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductsPageComponent} from './products-page.component';
import {RouterModule} from '@angular/router';
import {CmsPageGuard} from '@spartacus/storefront';
import {AuthGuard} from '@spartacus/core';
import {FormsModule} from '@angular/forms';

import {ClipboardModule} from '@angular/cdk/clipboard';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';
import {LoadingPageComponent} from '@dcp/configurator';

import '@sapudex/web-components/Tile.js';
import '@sapudex/web-components/dist/SegmentedButton.js';
import '@sapudex/web-components/dist/SegmentedButtonItem.js';
import '@ui5/webcomponents/Tree.js';
import '@ui5/webcomponents/TreeItem.js';
import '@ui5/webcomponents/TreeItemCustom.js';
import '@ui5/webcomponents/Icon.js';
import '@ui5/webcomponents-icons/detail-less.js';
import '@ui5/webcomponents-icons/detail-more.js';
import '@ui5/webcomponents-icons/expense-report.js';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'test/products',
        component: ProductsPageComponent,
        canActivate: [CmsPageGuard, AuthGuard],
      },
      {
        path: 'test/products/:productId',
        component: ProductsPageComponent,
        canActivate: [CmsPageGuard, AuthGuard],
      },
    ]),
    FormsModule,
    ClipboardModule,
    CartEditModule,
    LoadingPageComponent,
    ProductsPageComponent,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductsPageModule {}
